// HTMLElement 原生內建的方法 (不含生命週期)
// this.setAttribute() / getAttribute() / hasAttribute()
// this.dispatchEvent() / addEventListener() / removeEventListener()
// this.attachShadow({ mode: 'open' })
// this.shadowRoot

// 這邊 import 的 less 檔案是透過 raw-loader 處理，所以輸出結果是純文字
// import styleReset from '../reset.shadow.less';
import styleMessageToast from './message-toast.shadow.less';

// 兩種使用情境：
// 1. 單純在外部註冊為 Web Component 使用，此處不需要 export
//    直接 import 整個 js 檔即可
//    import '../../web-components/message-toast/message-toast';
// 2. 如果要作為其他元件的繼承基底，才需要 export class MessageToast
//    import {MessageToast} from '...';
//    class FancyComponent extends MessageToast
class MessageToast extends HTMLElement {
    constructor(){
        super();
        // attachShadow 會返回一個 ShadowRoot object
        // 與 this.shadowRoot 取得的對象相同
        this.root = this.attachShadow({ mode: 'open' });

        // 不依賴畫面狀態的程序，放在 constructor 中較佳 (相較於放在 connectedCallback)
        // 包括注入樣式、建立 shadow DOM、建立內部變數狀態等
        // this.applyStyle(styleReset);
        // 如果要做為基底元件，可選擇不要注入基底樣式，只注入 reset style
        this.applyStyle(styleMessageToast);

        // 初始化 shadow DOM 結構 (不含內容)
        this.init();

        // 必須手動綁定 this，否則不會正確的指向 this (web component 實體)
        // 語法說明：
        // this._handleResize = this._handleResize.bind(this);
    }

    // === 注入樣式 === //
    applyStyle(style){
        const elem = document.createElement('style');
        elem.textContent = style;
        this.root.appendChild(elem);
    }

    // === 初始化，在 constructor 中執行 === //
    init(){
        // 初始化 shadow DOM 結構 (不含內容)
        const wrapper = document.createElement('div');
        wrapper.className = 'wrapper';
        this.root.appendChild(wrapper);
    }

    // *** 以下四種內建的生命週期方法，都是 Callback 結尾 *** //

    // === 內建生命週期: 當元件被插入到 DOM 中時調用 === //
    // 與畫面實際出現、互動相關的行為，都應該放在 connectedCallback
    // 包括 UI 行為、事件綁定、資料載入、動畫等
    connectedCallback(){
        // addEventListener
        // window.addEventListener('resize', this._handleResize);
    }

    // === 內建生命週期: 當元件被移出 DOM 時調用 === //
    // 移除方法，在父層用 .remove() 從 DOM 中移除 <message-toast>
    // 如果有不是綁在 component 本身的東西
    // 在卸載時務必手動移除，以免造成 memory leak，例如以下幾種
    // 1. 綁定在 window, document, body 上的事件監聽器
    // 2. setInterval, setTimeout, WebSocket, MutationObserver 等
    disconnectedCallback(){
        // 綁定在 shadoe DOM 的事件監聽器會被自動移除，不用手動移除
        // 除此之外都需要手動移除
        // window.removeEventListener('resize', this._handleResize);
    }

    // === 內建生命週期: 當元件的屬性 (attributes) 變動時調用 === //
    // changed, added, removed, or replaced
    // 只有用 static get observedAttributes 列出的屬性才會被追蹤
    attributeChangedCallback(name, oldValue, newValue){
        // if(name === 'title'){
        //     // 例如更新文字內容
        //     // console.log(newValue); // -> Alice
        // }
        // if(name === 'active'){
        //     this.root.querySelector('p.active').textContent =
        //     `狀態:${newValue}`;
        // }
    }

    // 注意：如果要啟用 attributeChangedCallback()，需要搭配 getter
    // 用 static get 定義 observedAttributes
    // (瀏覽器會自動讀取 component.observedAttributes 值，來決定要監聽哪些屬性變化)
    // 所以需要指定哪些屬性需要監聽，當這些屬性改變時會觸發 attributeChangedCallback
    static get observedAttributes() {
        // ex: <message-toast title="Alice" active="running"><message-toast />
        // return ['title', 'active'];
    }

    // === 內建生命週期: 元件被移到另一個 document 時（如 iframe 之間) === //
    // 很少用，一般可略過
    adoptedCallback(){

    }

    // *** 以下為自訂方法 *** //

    // seeter 從外部接收資料
    // 當資料改變時可做相應的處理，例如更新內容等
    /** @param {(Object|Array)} [data=null] - 傳入資料 */
    set setData(data = null){
        const _data = {
            type: 'warning', // success, error, info, warning, custom
            content: '', // 訊息內容，可用 HTML
            // button: { // 自訂按鈕
            //     text: '變更密碼', // 按鈕文字
            //     // 向上傳遞的事件名稱
            //     name: 'message-toast-tcat-change-password',
            // },
            // closeButton: false, // 是否顯示關閉按鈕
        }
        this.render(data);
    }

    // === 根據資料產生內容 === //
    render(data){

        const wrapper = this.root.querySelector('.wrapper');

        const Html =
        `<div class="content ${data.type}">${data.content}</div>`;

        wrapper.innerHTML = Html;
    }

    // === 向外傳遞資料 === //
    // 利用 dispatchEvent 觸發自訂的事件，向上傳遞資料給父層
    dispatchCustomEvent(name, detail = {}) {
        this.dispatchEvent(new CustomEvent(name, {
            detail: detail,
            bubbles: true,
            composed: true
        }));
    }

    // === window.resize === //
    // _handleResize(){
        // 需要注意，以這個綁定在 window 上的事件處理器為例
        // 如果在 constructor 中不手動綁定 this
        // this._handleResize = this._handleResize.bind(this);
        // 那麼這邊預設指向的 this 會變成 window（或 undefined，如果是 strict mode）
    // }

}

// 單純在外部註冊為 Web Component 使用時
// 因為是匯入整個 js 檔，所以這一行會執行
customElements.define('message-toast', MessageToast);

// 從外部文件中匯入 web component 的使用範例
/*
import '../../web-components/message-toast/message-toast';

const component = document.createElement('message-toast');
document.body.appendChild(component);

component.setData = {
    title: 'Alice',
    active: '休眠'
};

component.setAttribute('active', '跑步');
*/

// === 取得容納 message-toast 的容器，如果沒有就建立一個 === //
export function getMessageToastWrapper(){

    const body = document.body;

    let wrapper = body.querySelector('#messageToastWrapper');

    if(!wrapper){
        wrapper = document.createElement('div');
        wrapper.id = 'messageToastWrapper';

        // 設定 top 位置，放置在 page-header 的下方
        // 但是因為 user.js 呼叫此函式時，page-header 還不存在
        // 所以必須以 main 為計算依據
        const main = body.querySelector('main');
        if(main){
            try {
                const style = window.getComputedStyle(main);
                // page-header 的高度固定為 45px
                const paddingTop = parseFloat(style.paddingTop) + 45;
                // console.log(paddingTop);
                wrapper.style.top = `${paddingTop}px`;

            } catch(error){
                console.log(error);
            }
        }

        body.appendChild(wrapper);
    }

    return wrapper;
}